// PIMS_FAQ FastAPI service — independent deployment, see Ref/faq_admin_integration_plan_20260810.md.
// Every endpoint requires a manually-passed `authorization` HTTP header (not a Bearer middleware),
// per the confirmed OpenAPI spec.
export const FAQ_API =
  process.env.REACT_APP_FAQ_API_URL ||
  "https://faq-api-service-1050393382437.us-central1.run.app";
